export default __webpack_public_path__ + "static/pudding_newspapers-f9dd1810cc251f08048abee26c901d85.png";